import React from "react";
import LandingQuickActions from "./LandingQuickActions";
import { sanitizeHtml } from "../../common/sanitizeHtml";

const Home = ({ children }) => {
  return (
    <div style={window._env_.REACT_APP_MENU_USE_PNG ? { backgroundImage: "url(\"" + window._env_.REACT_APP_URL + "/swirls-01.png\")", backgroundRepeat:"no-repeat", backgroundPosition:"center", height: "100%" } : {}}>
      <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(window._env_.HomePageText) }}></div>
      <div>{children}</div>
      <LandingQuickActions />
    </div>
  );
};

export default Home;
